import Vue from 'vue'
import router from '@/router'
import store from '@/store'
// import axios from 'axios'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN, MENU_LIST, USER_BTN } from '@/store/mutation-types'

NProgress.configure({ showSpinner: false })
// 设置白名单
const whiteList = ['login', 'homePage']

function handlerArray (arr) {
  const newArr = []
  function filter (list) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].children && list[i].children.length) {
        filter(list[i].children)
      } else {
        newArr.push(list[i])
      }
    }
  }
  filter(arr)
  return newArr
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  const flag = to.query.clould_token
  if (flag) {
    Vue.ls.set(ACCESS_TOKEN, flag)
    axios.post('/public/user/system?system=cloud', {})
      .then(res => {
        console.log(res)
        if (res.status === 200 && res.data.code === 0) {
          const result = res.data.result.menus
          const info = res.data.result.user
          const newMenus = handlerArray(result)
          const userBtn = newMenus.filter(item => item.mType === 2)
          Vue.ls.set(MENU_LIST, result)
          Vue.ls.set(USER_BTN, userBtn)
          store.commit('SET_TOKEN', flag)
          store.commit('SET_MENUS', result)
          store.commit('SET_USER_BTN', userBtn)
          store.commit('SET_INFO', info)
          store.commit('SET_NAME', info.nickName)
          store.commit('SET_AVATAR', info.headPath)
          store.state.has = false
          next({ name: 'home' })
        }
      })
      .catch(err => {
        if (err === undefined || err.__CANCEL__) {
          return
        }
        notification.error({
          title: '错误',
          message: err
        })
      })
  } else {
    if (Vue.ls.get(ACCESS_TOKEN)) {
      if (to.path === '/login') {
        next()
        NProgress.done()
      } else {
        const has = store.getters.has
        if (!has) {
          const menus = Vue.ls.get(MENU_LIST)
          store
            .dispatch('GenerateRoutes', menus)
            .then(res => {
              router.addRoutes(store.getters.addRouters)
              const redirect = decodeURIComponent(to.path)
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
            .catch(() => {
              notification.error({
                message: '错误',
                description: '请求用户信息失败，请重新登录'
              })
              next('/login')
            })
        } else {
          next()
        }
      }
    } else {
      if (whiteList.includes(to.name)) {
        next()
      } else {
        next('/login')
        NProgress.done()
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
